 import React from 'react';
import '../App.css';

function NotFound() {
  return (
    <div className="App">
      <header className="App-header">
        <h1> 404 </h1>
      </header>
    </div>
  );
}

export default NotFound;
